<div class="glass-house-variant-type-and-label">
  <div
    appPrintCardScaleDownText
    [transparentWhileScaling]="viewingInLiveView"
    [adjustLineHeight]="false"
    [maxWidthInPx]="265"
    [maxHeightInPx]="25"
    class="glass-house-variant-type">
    {{ data | method: 'rowVariantType' | trimSafely }}
  </div>
  <app-label-inflator
    *ngIf="hasLabelText"
    class="glass-house-label"
    [columnLabel]="false"
    [labelComponentInterface]="data"
    [reset]="false">
  </app-label-inflator>
</div>
